import { Injectable } from '@angular/core';
import { ChangeTyped, IndexedService, SAVED_SEARCH_STORE } from '@damofire/data-commons';
import { SavedSearchService } from './saved-search.service';
import { SavedSearch } from './saved-search.dto';
import { AuthDtoSignerService } from '@damofire/data-security';
import { WarehouseSyncEventService } from '../sync/warehouse-sync-event.service';
import { LockingIndexedService } from '../indexed/locking-indexed.service';

@Injectable()
export class IdbSavedSearchService extends SavedSearchService {
  constructor(
    private readonly idbService: IndexedService,
    private readonly lockingIndexedService: LockingIndexedService,
    private readonly dtoSigner: AuthDtoSignerService,
    private readonly warehouseSyncEventService: WarehouseSyncEventService,
  ) {
    super();
  }

  async create(savedSearch: Partial<SavedSearch>): Promise<SavedSearch> {
    savedSearch._id = this.dtoSigner.generateId();
    await this.dtoSigner.sign(savedSearch, true);
    await this.idbService.add(SAVED_SEARCH_STORE, savedSearch);

    const changeTyped: ChangeTyped<SavedSearch> = { ...savedSearch, changeType: 'added' };
    this.warehouseSyncEventService.publishOutput({ division: savedSearch.division._id, changes: [changeTyped], store: SAVED_SEARCH_STORE });
    return savedSearch;
  }

  async update(update: SavedSearch): Promise<void> {
    await this.dtoSigner.sign(update);
    await this.idbService.update(SAVED_SEARCH_STORE, update);

    const changeTyped: ChangeTyped<SavedSearch> = { ...update, changeType: 'modified' };
    this.warehouseSyncEventService.publishOutput({ division: update.division._id, changes: [changeTyped], store: SAVED_SEARCH_STORE });
  }

  async delete(division: string, id: string): Promise<void> {
    await this.idbService.delete(SAVED_SEARCH_STORE, [division, id]).catch(console.error);
    this.warehouseSyncEventService.publishOutput({
      division,
      changes: [{ _id: id, changeType: 'removed' } as ChangeTyped<SavedSearch>],
      store: SAVED_SEARCH_STORE,
    });
  }

  async get(divisionId: string, id: string): Promise<SavedSearch> {
    return this.lockingIndexedService.getByKey<SavedSearch>(divisionId, SAVED_SEARCH_STORE, [divisionId, id]);
  }
}
